import { render } from "./PaginationProducts.vue?vue&type=template&id=0c1c3abe"
import script from "./PaginationProducts.vue?vue&type=script&lang=js"
export * from "./PaginationProducts.vue?vue&type=script&lang=js"

import "./PaginationProducts.vue?vue&type=style&index=0&id=0c1c3abe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__